import { render, staticRenderFns } from "./InformasiLaporanUmpd.vue?vue&type=template&id=55713bec&"
import script from "./InformasiLaporanUmpd.vue?vue&type=script&lang=js&"
export * from "./InformasiLaporanUmpd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports